import React from "react";
import { Link } from "react-router-dom";

function CartItem(props) {

/*
  function updateQty(e) {
    let qty = e.target.value;
    props.updateQty(props.item.id_e_products, qty);
  }
  function convert(num) {
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
*/
  return (
    <>
      <div className="articolo_cart">
        <div className="img_articolo_cart">
          <div
            className="ico_cestino_cart"
            onClick={() => props.itemRemoval(props.item.id_e_products)}
          >
            <img
              className="AW-carrello-rimuovi"
              src="/images/croce_cart_on.svg"
              alt="Rimuovi"
              title="Rimuovi"
              name=""
            />
          </div>
          <Link to={props.urlItem}>
            <img
              src={props.urlImg}
              alt={props.item.details[0].images[0].alt}
              title={props.item.details[0].nome}
            />
          </Link>
        </div>
        <div className="dati_articolo_cart">
          <Link to={props.urlItem}>
            <h2>{props.item.details[0].nome}</h2>
          </Link>
          <h3>Codice: {props.item.details[0].codice}</h3>
        </div>

        <div className="prezzo_cart">
          <p>
            <span>Prezzo:</span>&euro; {props.convert(props.item.prezzo_unitario)}
          </p>
        </div>

        <div className="qta_cart">
          <div className="qta_giu_cart" onClick={() => props.incrementQty(props.item.id_e_products, -1)}>
            <p>-</p>
          </div>
          <div className="qta_num_cart">
            <input
              type="number"
              className="AW-inputQty"
              name="Qty"
              id="Qty"
              value={parseInt(props.item.quantita_carrello)}
              readOnly
              //onChange={(e) => updateQty(e)}
            />
          </div>
          <div className="qta_su_cart" onClick={() => props.incrementQty(props.item.id_e_products, 1)}>
            <p>+</p>
          </div>
        </div>

        <div className="totale_cart">
          <p>
            <span>Totale:</span>&euro;&nbsp;
            {props.convert(props.item.prezzo_finale)}
          </p>
        </div>
      </div>
      <div className="AW-clear"></div>
    </>
  );
}

export default CartItem;